// extracted by mini-css-extract-plugin
module.exports = {"disabledLink":"AuthEnabledLink_disabledLink__2QxZ_"};